import React from "react";
import {connect} from "react-redux";
import styled from "styled-components";
import {AppearFromBottom, QuicklinkButton, QuickLinkText} from "global/style";
import {translate, language} from "_helpers/general.helper";
import {chatActions} from "_actions";
import { sendRequest } from '_helpers/request.helper';


const MultibotQuicklinksContainer = styled.div`
  padding-left: 80px;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    padding-left: 3px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    padding-left: 0;
  }
`;

const MultibotQuicklinksWrapper = styled(AppearFromBottom)`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-content: space-between;
  padding-left: 0;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-item-align: flex-start;
  align-self: center;
  -webkit-box-align: start;
  -ms-flex-align: start;
  grid-gap: 7px;
  margin-bottom: 5px;
  margin-left: -8px;

`;

const MultibotText = styled(QuickLinkText)`
  font-family: Dm sans;
  font-weight: 700;
  text-align: left;
  padding: 0;
  justify-content: flex-start;
  border: 2px solid ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinksBorderColorGray};
  width: 250px;
  border-radius: 8px;
  padding-left: 12px !important;
  padding-right: 6px !important;
  height: 100px;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    width: 225px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    width: 395px;
    height: 131px;
    border-radius: 100px;
  }
`;
const QuickLinkUnits = styled.div`
    color: white;
    background: #42accd;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    margin-bottom: -11px;
    width: fit-content;
    padding-left: 15px;
    padding-right: 15px;

    ${(props) => props.theme.themeColors.light.new_branding === "1" && ` background: #4B8D71;`}
`

const QuicklinkAddress = styled.div`
  display: flex;
  align-items: center;
  min-height: 30px;
  font-family: DM sans;
  font-style: normal;
  font-weight: normal;

  color: ${(props) => props.theme.themeColors[props.theme.activeTheme].otherPropertiesAddress};
  width: 135px;
  height: 27px;

  font-size: 9px;
  line-height: 10px;

  @media screen and (min-width: ${(props) =>
  props.theme.screenSizes.breakLaptop}) {
    font-size: 12px;
    line-height: 14px;
    width: 204.39px;
    height: 38.32px;
  }
`;

const QuicklinkImage = styled.img`
  border-radius: 50%;
  border: 4px solid #42ACCD;
  box-sizing: border-box;
  width: 60px;
  height: 60px;
  margin: 0 7px 0 7px;

  @media screen and (min-width: ${(props) =>
  props.theme.screenSizes.breakSmall}) {
    width: 64px;
    height: 64px;
    margin: 0 7px 0 0;
  }

  @media screen and (min-width: ${(props) =>
  props.theme.screenSizes.breakLaptop}) {
    width: 103.61px;
    height: 103.61px;
    margin: 0 10px 0 5px;
  }
`;

const PropertyText = styled.span`
  font-family: DM sans;
  font-size: 14px;
  line-height: 16.8px;

  @media screen and (min-width: ${(props) =>
  props.theme.screenSizes.breakSmall}) {
    font-size: 14px;
    line-height: 19px;
  }

  @media screen and (min-width: ${(props) =>
  props.theme.screenSizes.breakLaptop}) {
    font-size: 22px;
    line-height: 29px;
  }
`;

function Multibot({data, tid, userId, send, propertyType}) {
  const handleClick = (property) => {
    const parsedTid = property.value.split("-")[1];
    let floorplanIntent = propertyType == 'Student' ? 'TermsListFloorplansConversation' : 'ListFloorplansConversation';
    // -10 unit count is a flag which indicates there is no overlapping term in the nearby property 
    // The user that is redirected to the nearby bot should select a term
    if (property.units == -10) {
        floorplanIntent = 'Terms-Search-TermsConversation'
    }
    if (property.value.startsWith('NearbyPropertiesSelect')) {
        window.open(process.env.REACT_APP_API_TRANSFER +
            window.location.host.replace(tid, parsedTid) +
            `/${floorplanIntent}?user_id=` +
            userId, '_blank').focus();
        
        logOpenedNearbyProperty(tid, property.value)
        return;
    }

    send(property, "text");
    window.location =
      process.env.REACT_APP_API_TRANSFER +
      window.location.host.replace(tid, parsedTid) +
      "?user_id=" +
      userId;
  };

  const logOpenedNearbyProperty = (tid, value) => {
    const url = `${process.env.REACT_APP_API_TRANSFER}${tid}.${process.env.REACT_APP_API_URL}talk`;
    let data = new FormData();
    data.append('tid', tid);
    data.append('userId', userId);
    data.append('message', value);
    data.append('language', "English");
    data.append('driver', 'web');

    sendRequest('POST', url, data).then(
        (result) => {
            // do nothing just store in conversation_log as NearbyPropertiesSelect-{tid} 
        }
    )
  }

  const handleKeyPress = (e, property) => {
    if (e.key === "Enter" || e.key === " ") {
      handleClick(property);
    }
  };

  const handleImageLoadFail = (e) => {
    e.target.src =
      process.env.REACT_APP_AWS_URL +
      "uploads/floorplans/default.png?h=500&w=620&zc=2";
  };

  return (
    <MultibotQuicklinksContainer className="MultibotQuicklinksContainer">
      <MultibotQuicklinksWrapper className="MultibotQuicklinksWrapper">
        {data.map((property, key) => {
          return (
            <QuicklinkButton
              key={`multibot-quicklink-${key}`}
              onClick={() => handleClick(property)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => handleKeyPress(e, property)}
            >
              <MultibotText className="MultibotText quicklinks" tabIndex={-1}>
                <QuicklinkImage
                  onError={handleImageLoadFail}
                  src={property.image}
                  alt="Property thumbnail"
                />
                <div>
                  <PropertyText>{property.text}</PropertyText>
                  <QuicklinkAddress className="QuicklinkAddress">
                    <span>{property.address}</span>
                  </QuicklinkAddress>
                  {property.units > 0 &&
                    <QuickLinkUnits>
                      <p>{property.units} {translate(property.units > 1 ? 'Units available' : 'Unit available', language(tid))}</p>
                    </QuickLinkUnits>
                  }
                </div>
              </MultibotText>
            </QuicklinkButton>
          );
        })}
      </MultibotQuicklinksWrapper>
    </MultibotQuicklinksContainer>
  );
}

const mapStateToProps = (state) => ({
  tid: state.settings.tid,
  userId: state.settings.userId,
  propertyType: state.property.property_type
});

const actions = {
  send: chatActions.send,
};

export default connect(mapStateToProps, actions)(Multibot);
